/**
 * Sonido ambiental opcional.
 *
 * Solo comienza tras una interacción del usuario (requisito de los navegadores
 * y del enunciado). Si el juego no declara audio, el control se oculta.
 */
export class SoundManager {
  private audio: HTMLAudioElement | null = null;
  private currentSrc: string | null = null;
  private enabled = false;
  private unlocked = false;

  constructor(private readonly baseUrl = '') {}

  get isEnabled(): boolean {
    return this.enabled;
  }

  setEnabled(value: boolean): void {
    this.enabled = value;
    if (!value) {
      this.audio?.pause();
      return;
    }
    if (this.unlocked && this.currentSrc) this.playCurrent();
  }

  /** Marca que ya hubo interacción del usuario; permite reproducir. */
  unlock(): void {
    this.unlocked = true;
    if (this.enabled && this.currentSrc) this.playCurrent();
  }

  setAmbient(src: string | undefined): void {
    if (!src) {
      this.audio?.pause();
      this.currentSrc = null;
      return;
    }
    // Si es base64 (data: URL), usar directamente; si no, prepend baseUrl
    const full = src.startsWith('data:') ? src : this.baseUrl + src;
    if (full === this.currentSrc) return;
    this.currentSrc = full;
    if (this.enabled && this.unlocked) this.playCurrent();
  }

  private playCurrent(): void {
    if (!this.currentSrc) return;
    try {
      if (!this.audio) {
        this.audio = new Audio();
        this.audio.loop = true;
        this.audio.volume = 0.35;
      }
      if (this.audio.src !== this.currentSrc) this.audio.src = this.currentSrc;
      void this.audio.play().catch(() => {
        /* reproducción bloqueada; se reintentará tras otro gesto */
      });
    } catch {
      /* audio no disponible */
    }
  }

  destroy(): void {
    this.audio?.pause();
    this.audio = null;
    this.currentSrc = null;
  }
}
